export const COMP_ERROR = 'comp_error',
  PIN_ERROR = 'pin_error',
  POINT_ERROR = 'point_error',
  NET_ERROR = "net_not_same_error",
  POINT_SAME_ERROR = "point_same_error",
  NO_NET_ERROR = "no_net_error";